import script from "./ViewMyPokemons.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMyPokemons.vue?vue&type=script&setup=true&lang=js"

import "./ViewMyPokemons.vue?vue&type=style&index=0&id=0e7c340d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e7c340d"]])

export default __exports__